import { useEffect } from "react";

/**
 * Redirects old subdomains to their corresponding pages on the main domain.
 * This component should be rendered at the top level, before routing.
 * 
 * Handles all legacy URLs from the old subdomain structure.
 */

// Redirect configuration based on the migration CSV
const redirectRules: Array<{ host: string; path: string; target: string }> = [
  // knorr-consulting.nikola-knorr.de
  { host: "knorr-consulting.nikola-knorr.de", path: "/", target: "https://nikola-knorr.de/consulting/" },
  { host: "knorr-consulting.nikola-knorr.de", path: "/supervision/", target: "https://nikola-knorr.de/consulting/supervision/" },
  { host: "knorr-consulting.nikola-knorr.de", path: "/supervision/einzelleitungssupervision-fuehrungskraefte/", target: "https://nikola-knorr.de/consulting/coaching/" },
  { host: "knorr-consulting.nikola-knorr.de", path: "/teamentwicklung/", target: "https://nikola-knorr.de/consulting/supervision/" },
  { host: "knorr-consulting.nikola-knorr.de", path: "/teamentwicklung/teamsupervision/", target: "https://nikola-knorr.de/consulting/supervision/" },
  { host: "knorr-consulting.nikola-knorr.de", path: "/teamentwicklung/kommunikationstraining/", target: "https://nikola-knorr.de/consulting/supervision/" },
  { host: "knorr-consulting.nikola-knorr.de", path: "/teamentwicklung/konflikttraining/", target: "https://nikola-knorr.de/consulting/supervision/" },
  { host: "knorr-consulting.nikola-knorr.de", path: "/strategieentwicklung/", target: "https://nikola-knorr.de/consulting/strategieentwicklung/" },
  { host: "knorr-consulting.nikola-knorr.de", path: "/burnoutvorsorge-nachsorge/", target: "https://nikola-knorr.de/consulting/coaching/" },
  { host: "knorr-consulting.nikola-knorr.de", path: "/referenzen/", target: "https://nikola-knorr.de/consulting/" },
  { host: "knorr-consulting.nikola-knorr.de", path: "/vita/", target: "https://nikola-knorr.de/zur-person/" },
  { host: "knorr-consulting.nikola-knorr.de", path: "/kontakt/", target: "https://nikola-knorr.de/kontakt/" },
  { host: "knorr-consulting.nikola-knorr.de", path: "/blog/", target: "https://nikola-knorr.de/consulting/wissen/" },
  { host: "knorr-consulting.nikola-knorr.de", path: "/online-angebot/", target: "https://nikola-knorr.de/mensch-im-fokus/praesenz-und-online/" },
  { host: "knorr-consulting.nikola-knorr.de", path: "/impressum/", target: "https://nikola-knorr.de/impressum/" },
  { host: "knorr-consulting.nikola-knorr.de", path: "/datenschutz/", target: "https://nikola-knorr.de/datenschutz/" },
  
  // mensch-im-fokus.nikola-knorr.de
  { host: "mensch-im-fokus.nikola-knorr.de", path: "/", target: "https://nikola-knorr.de/mensch-im-fokus/" },
  { host: "mensch-im-fokus.nikola-knorr.de", path: "/gestalttherapie/", target: "https://nikola-knorr.de/mensch-im-fokus/gestaltpsychotherapie/" },
  { host: "mensch-im-fokus.nikola-knorr.de", path: "/gestalttherapie/einzeltherapie/", target: "https://nikola-knorr.de/mensch-im-fokus/gestaltpsychotherapie/" },
  { host: "mensch-im-fokus.nikola-knorr.de", path: "/gestalttherapie/paartherapie/", target: "https://nikola-knorr.de/mensch-im-fokus/beratung-paare-familien/" },
  { host: "mensch-im-fokus.nikola-knorr.de", path: "/gestalttherapie/familientherapie/", target: "https://nikola-knorr.de/mensch-im-fokus/beratung-paare-familien/" },
  { host: "mensch-im-fokus.nikola-knorr.de", path: "/yoga/", target: "https://nikola-knorr.de/mensch-im-fokus/yoga/" },
  { host: "mensch-im-fokus.nikola-knorr.de", path: "/yoga/yoga-einzeltraining/", target: "https://nikola-knorr.de/mensch-im-fokus/yoga/einzelunterricht/" },
  { host: "mensch-im-fokus.nikola-knorr.de", path: "/yoga/yoga-workshops-old/", target: "https://nikola-knorr.de/mensch-im-fokus/yoga/seminare/" },
  { host: "mensch-im-fokus.nikola-knorr.de", path: "/yoga/yoga-fuer-krebspatientinnen/", target: "https://nikola-knorr.de/mensch-im-fokus/yoga/onko-yoga/" },
  { host: "mensch-im-fokus.nikola-knorr.de", path: "/umgang-mit-konflikten/", target: "https://nikola-knorr.de/mensch-im-fokus/beratung-paare-familien/" },
  { host: "mensch-im-fokus.nikola-knorr.de", path: "/umgang-mit-konflikten/konfliktklaerung-mediation/", target: "https://nikola-knorr.de/mensch-im-fokus/beratung-paare-familien/" },
  { host: "mensch-im-fokus.nikola-knorr.de", path: "/umgang-mit-konflikten/konflikttraining/", target: "https://nikola-knorr.de/mensch-im-fokus/beratung-paare-familien/" },
  { host: "mensch-im-fokus.nikola-knorr.de", path: "/artikel/", target: "https://nikola-knorr.de/mensch-im-fokus/yoga/wissen/" },
  { host: "mensch-im-fokus.nikola-knorr.de", path: "/yoga-und-bluthochdruck/", target: "https://nikola-knorr.de/mensch-im-fokus/yoga/wissen/artikel/yoga-und-bluthochdruck/" },
  { host: "mensch-im-fokus.nikola-knorr.de", path: "/supervision-an-der-grenze-personzentrierte-supervision.../", target: "https://nikola-knorr.de/consulting/wissen/personzentrierte-supervision-hospiz-palliativ/" },
  { host: "mensch-im-fokus.nikola-knorr.de", path: "/atemuebungen-im-yoga/", target: "https://nikola-knorr.de/mensch-im-fokus/yoga/wissen/" },
  { host: "mensch-im-fokus.nikola-knorr.de", path: "/vita/", target: "https://nikola-knorr.de/zur-person/" },
  { host: "mensch-im-fokus.nikola-knorr.de", path: "/kontakt/", target: "https://nikola-knorr.de/kontakt/" },
  { host: "mensch-im-fokus.nikola-knorr.de", path: "/online-angebot/", target: "https://nikola-knorr.de/mensch-im-fokus/praesenz-und-online/" },
  { host: "mensch-im-fokus.nikola-knorr.de", path: "/impressum/", target: "https://nikola-knorr.de/impressum/" },
  { host: "mensch-im-fokus.nikola-knorr.de", path: "/datenschutz/", target: "https://nikola-knorr.de/datenschutz/" },
];

// Normalize path for matching (handle with/without trailing slash)
const normalizePath = (path: string): string => {
  if (path === "/") return "/";
  return path.endsWith("/") ? path : path + "/";
};

// Get hostname without www prefix for matching
const normalizeHost = (host: string): string => {
  return host.startsWith("www.") ? host.substring(4) : host;
};

const SubdomainRedirect = () => {
  useEffect(() => {
    const hostname = window.location.hostname;
    const pathname = window.location.pathname;
    
    const normalizedHost = normalizeHost(hostname);
    const normalizedPath = normalizePath(pathname);
    
    // Check if we're on an old subdomain
    const isOldSubdomain = 
      normalizedHost === "knorr-consulting.nikola-knorr.de" ||
      normalizedHost === "mensch-im-fokus.nikola-knorr.de";
    
    if (isOldSubdomain) {
      // Find exact match first
      const exactMatch = redirectRules.find(
        rule => normalizeHost(rule.host) === normalizedHost && normalizePath(rule.path) === normalizedPath
      );
      
      if (exactMatch) {
        window.location.replace(exactMatch.target);
        return;
      }
      
      // Fallback: redirect to base section
      const fallbackTarget = normalizedHost === "knorr-consulting.nikola-knorr.de" 
        ? "https://nikola-knorr.de/consulting/"
        : "https://nikola-knorr.de/mensch-im-fokus/";
      
      window.location.replace(fallbackTarget);
    }
  }, []);

  return null;
};

export default SubdomainRedirect;
